import { memo } from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, NodeToRenderData } from './types/custom-nodes.type';
import { applyIfConditionHocs } from '../../scenario-editor/utils';
import { CustomTooltip } from '../tooltip/Tooltip';

export const MenuItem = ({ children, className, ...props }: NodeToRenderProps) => {
  return (
  <div
    className={
      cn([
        "flex rounded-md p-2 pr-3 border-2 border-transparent bg-input h-full justify-center items-center w-fit text-sm truncate",
        className,
      ])
    }
    {...props}
  >{children}</div>
)};

export const NodeItem = ( props: NodeToRenderProps) => {
  return (
    <div
      data-testid={`node=>${(props.data as NodeToRenderData).nodeType}`}
      className={
        cn([
          props.className,
          "flex flex-col py-2 px-2 rounded-md bg-transparent border-2 border-transparent justify-center items-center w-fit text-sm h-[65px]",
        ])
      }
      style={props.style}
    >
      <CustomTooltip content="If condition based on previous multi selection">
        <p className="text-center text-sm truncate max-w-full break-all">If</p>
      </CustomTooltip>
      <div className={cn([
        "bg-input rotate-45 w-[50px] h-[50px] absolute rounded -z-0",
        {
          'border-2': props.selected,
          '!border-blue-400': props.selected,
        }
      ])}></div>

    </div>
  )
};

const WrappedNodeToRender = applyIfConditionHocs(NodeItem);

const IfCondition: React.FC<NodeToRenderProps> = (props: NodeToRenderProps) => {
  const { title } = props.data as NodeToRenderData;
  return (
    <>
      <WrappedNodeToRender {...props}>{title}</WrappedNodeToRender>
    </>
  );
};

export const IfConditionNode = memo(IfCondition);
